<template>
  <div>
    <!--------------- start toast / snackbar ------------------------------>
    <success-toast-component :SuccessToast="SuccessToast" @close="close" />
    <error-toast-component :ErrorToast="ErrorToast" @close="close" />
    <!--------------- end toast / snackbar ------------------------------>
    <div>
      <!------------------Practitioner Start Section------------------------>
      <v-row class="d-flex justify-space-between">
        <v-col>
          <h1 class="heading-1">Practitioners</h1>
        </v-col>
      </v-row>
      <!------------------Search And Filter------------------------>
      <v-row class="mt-6">
        <v-col cols="12" md="4" sm="6" class="pb-0">
          <v-card flat>
            <v-text-field
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label="Search"
              single-line
              v-model="search"
            >
            </v-text-field>
          </v-card>
        </v-col>
        <v-col cols="12" md="2" sm="6" class="pb-0">
          <v-card flat>
            <v-select
              dense
              outlined
              prepend-inner-icon="mdi-tune"
              label="Filters"
              single-line
            >
            </v-select>
          </v-card>
        </v-col>
      </v-row>
      <!------------------End Search Filter ------------------------>

      <!------------------Datatables------------------------>
      <v-card class="mt-4" outlined>
        <v-data-table
          :headers="headers"
          :search="search"
          :items="DataTableOne"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
          hide-default-footer
        >
          <template v-slot:[`item.index`]="{ item }">
            <b class="index_index_text"> {{ item.index }} </b>
          </template>
          <template v-slot:[`item.images`]="{ item }">
            <div style="display: flex; align-items: center" class="px-2 pa-2">
              <v-avatar>
                <img :src="item.images" alt="John" />
              </v-avatar>
              <div>
                <p class="mb-0 mx-3 index_h3">
                  {{ item.name }}
                </p>
              </div>
            </div>
          </template>
          <template v-slot:[`item.type`]="{ item }">
            <span class="index_head_text"> {{ item.type }} </span>
          </template>
          <template v-slot:[`item.courses`]="{ item }">
            <span class="index_head_text"> {{ item.courses }} </span>
          </template>
          <template v-slot:[`item.students`]="{ item }">
            <span class="index_head_text"> {{ item.students }} </span>
          </template>
          <template v-slot:[`item.actions`]>
            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="#A1A1A6" v-bind="attrs" v-on="on">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card flat>
                <!------------------List Practioner dialog start------------------------>
                <v-list class="px-3 pt-1" color="transparent">
                  <router-link
                    to="practitioners/practionerprofile"
                    style="text-decoration: none"
                    v-if="Permission.View"
                  >
                    <v-btn
                      depressed
                      color="transparent"
                      block
                      class="d-flex justify-start"
                    >
                      <i
                        class="fa-solid fa-arrow-up-right-from-square"
                        style="font-size: 0.9vw"
                      ></i>
                      <span class="ml-4 text_style">See Profile</span>
                    </v-btn>
                  </router-link>
                </v-list>
                <!------------------Practioner Profile Dialog------------------------>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="previewDialog = true"
                  >
                    <v-icon color="#646464">mdi-eye</v-icon>
                    <span class="ml-4 text_style">See Profile</span>
                  </v-btn>
                </v-list>
                <!------------------ End Practioner Profile Dialog------------------------>
                <v-list
                  class="px-3 pt-1"
                  color="transparent"
                  v-if="Permission.Edit"
                >
                  <!------------------ Start Practioner Edit Dialog------------------------>
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="editdialog = true"
                  >
                    <v-icon color="#646464">mdi-pencil</v-icon>
                    <span class="ml-4 text_style">Edit</span>
                  </v-btn>
                  <!------------------ End Practioner Edit Dialog------------------------>
                </v-list>
                <v-list
                  class="px-3 pt-1"
                  color="transparent"
                  v-if="Permission.Delete"
                >
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="dialog = true"
                  >
                    <v-icon color="#646464">mdi-delete</v-icon>
                    <span class="ml-4 text_style action_dialog">Delete</span>
                  </v-btn>
                </v-list>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
      <!--End Datatbales-->
      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination
      ></v-card>
    </div>
    <!-----------------information dialoag---------------------->
    <v-dialog
      v-model="previewDialog"
      @click:outside="closeDialog"
      persistent
      max-width="720"
    >
      <v-card>
        <div class="mx-5 py-2 d-flex justify-space-between">
          <h5></h5>
          <v-card class="mt-2" style="border-radius: 50px" outlined>
            <v-icon @click="previewDialog = false"> mdi-dots-horizontal</v-icon>
          </v-card>
        </div>

        <div>
          <practitionerprofile />
        </div>
        <div class="d-flex justify-end mx-5 py-5">
          <v-btn
            style="color: rgba(8, 8, 22, 0.54); border: 1px solid #f2f2f2"
            depressed
            rounded
            outlined
            class="px-10"
            @click="previewDialog = false"
          >
            Close
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!-----------------See profile dialoag---------------------->
    <v-dialog
      v-model="previewDialog"
      @click:outside="closeDialog"
      persistent
      max-width="720"
    >
      <v-card>
        <div class="mx-5 py-2 d-flex justify-space-between">
          <h5></h5>
          <v-card class="mt-2" style="border-radius: 50px" outlined>
            <v-icon @click="previewDialog = false"> mdi-dots-horizontal</v-icon>
          </v-card>
        </div>

        <div>
          <practitionerprofile />
        </div>
        <div class="d-flex justify-end mx-5 py-5">
          <v-btn
            style="color: rgba(8, 8, 22, 0.54); border: 1px solid #f2f2f2"
            depressed
            rounded
            outlined
            class="px-10"
            @click="previewDialog = false"
          >
            Close
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!-----------------Edit dialoag---------------------->
    <v-dialog v-model="editdialog" persistent max-width="520">
      <v-card>
        <div class="mx-5 py-5 d-flex justify-space-between">
          <span class="heading-2">Edit practitioner</span>
          <v-icon @click="editdialog = false">mdi-close</v-icon>
        </div>
        <div>
          <edit-practitioners />
        </div>
        <div class="text_tarns d-flex justify-end mx-5 py-5">
          <v-btn
            class="text_tarns px-14 py-6"
            color="#A1A3A8"
            text
            @click="editdialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            depressed
            color="primary"
            class="text_tarns px-14 py-6"
            @click="send()"
          >
            <span class="text_style" v-if="btnloader != true">Save</span>
            <v-progress-circular
              v-else
              indeterminate
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!-----------------Delete dialoag---------------------->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="DdialogClose()">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EditPractitioners from "../../components/practitioners/EditPractitioners.vue";
import Practitionerprofile from "../../components/practitioners/practitionerprofile.vue";
//import SeeMoreInfo from "../../components/practitioners/SeeMoreInfo.vue";
import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    //SeeMoreInfo,
    EditPractitioners,
    Practitionerprofile,
    ErrorToastComponent,
    SuccessToastComponent,
  },
  data() {
    return {
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      Permission: {},
      ErrorToast: false,
      SuccessToast: false,
      dialog: false,
      infodialog: false,
      tableLoader: false, // data-table true or false
      SeeProfileDialog: false,
      previewDialog: false,
      editdialog: false,
      add_dialog: false,
      btnloader: false,
      search: "",
      props: ["value"],
      headers: [
        { text: "#", value: "index" },
        { text: "User", value: "images" },
        { text: "Type", value: "type" },
        { text: "Courses", value: "courses" },
        { text: "Students", value: "students" },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [],
    };
  },
  computed: {
    ...mapGetters(["GetUserRolePermissions"]),
  },
  mounted() {
    this.Permission = this.GetUserRolePermissions.RolePermissions.find(
      (x) => x.Module === "Practitioners"
    );
    this.tableLoader = true;
    setTimeout(() => {
      (this.DataTableOne = [
        {
          index: 123,
          images:
            "https://images.unsplash.com/photo-1606229155208-1a5e7bfead60?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=723&q=80",
          name: "Floyd Miles",
          type: "Instructor",
          courses: "28",
          students: "1230",
        },
        {
          index: 123,
          images:
            "https://images.unsplash.com/photo-1606229155208-1a5e7bfead60?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=723&q=80",
          name: "Brooklyn Simmons",
          type: "Practitioner",
          courses: "28",
          students: "1230",
        },
        {
          index: 123,
          images: "https://cdn.vuetifyjs.com/images/john.jpg",
          name: "Ronald Richrads",
          type: "Instructor",
          courses: "28",
          students: "1230",
        },
        {
          index: 123,
          images:
            "https://images.unsplash.com/photo-1606229155208-1a5e7bfead60?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=723&q=80",
          name: "Jane Cooper",
          type: "Instructor",
          courses: "28",
          students: "1230",
        },
        {
          index: 123,
          images: "https://picsum.photos/250/250/?image=58",
          name: "Ralph Edwards",
          type: "Instructor",
          courses: "28",
          students: "1230",
        },
        {
          index: 123,
          images: "https://picsum.photos/10/6",
          name: "Guy Hawkins",
          type: "Instructor",
          courses: "28",
          students: "1230",
        },
        {
          index: 123,
          images: "https://picsum.photos/250/250/?image=54",
          name: "Jenny Wilson",
          type: "Instructor",
          courses: "28",
          students: "1230",
        },
        {
          index: 123,
          images: "https://placekitten.com/320/320",
          name: "Annette Black",
          type: "Instructor",
          courses: "28",
          students: "1230",
        },
        {
          index: 123,
          images: "https://placekitten.com/300/300",
          name: "Jerome Bell",
          type: "Instructor",
          courses: "28",
          students: "1230",
        },
        {
          index: 123,
          images: "https://picsum.photos/250/250/?image=59",
          name: "Kristin Watson",
          type: "Instructor",
          courses: "28",
          students: "1230",
        },
      ]),
        (this.tableLoader = false);
    }, 1500);
  },
  methods: {
    DdialogClose() {
      this.dialog = false;
      this.ErrorToast = true;
      setTimeout(() => {
        this.ErrorToast = false;
      }, 1500);
    },
    closeDialog() {
      this.value = false;
    },
    goBack() {
      this.isHidden = false;
      
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.editdialog = false;
        this.btnloader = false;
        this.SuccessToast = true;
      }, 2000);
      setTimeout(() => {
        this.SuccessToast = false;
      }, 3000);
    },
    close() {
      this.ErrorToast = false;
    },
  },
};
</script>
<style scoped>
.index_index_text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  text-align: center;

  /* Color/General/Black High Emphasis */

  color: #222222;
}
.index_head_text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;

  /* Color/General/Black High Emphasis */

  color: #222222;
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
.text_tarns {
  text-transform: none;
}
</style>
